module.exports = __webpack_public_path__ + "static/media/Project-usa.9d0b66f1.svg";